import { useRef, useState } from "react";
import { Loader2, Play, Square } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";
import { toast } from "sonner";

// Plays a short cached spoken sample of an ElevenLabs voice.
export default function VoicePreviewButton({ voiceId, size = "icon", className = "" }) {
  const [state, setState] = useState("idle");
  const audioRef = useRef(null);

  const stop = () => {
    if (audioRef.current) { audioRef.current.pause(); audioRef.current = null; }
    setState("idle");
  };

  const play = async () => {
    if (state === "playing") { stop(); return; }
    if (!voiceId) return;
    setState("loading");
    try {
      const res = await fetch(`${API}/elevenlabs/voices/${voiceId}/preview`, { credentials: "include" });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "preview failed");
      const url = URL.createObjectURL(await res.blob());
      const a = new Audio(url);
      audioRef.current = a;
      a.onended = () => { URL.revokeObjectURL(url); stop(); };
      await a.play();
      setState("playing");
    } catch (e) {
      toast.error(typeof e.message === "string" ? e.message : "Aperçu indisponible.");
      setState("idle");
    }
  };

  return (
    <Button type="button" variant="outline" size={size} onClick={play} disabled={!voiceId || state === "loading"} title="Écouter un aperçu de cette voix"
      className={`border-secondary/40 text-secondary hover:bg-secondary/10 shrink-0 ${className}`} data-testid={`voice-preview-${voiceId || "none"}`}>
      {state === "loading" ? <Loader2 className="animate-spin" size={15} /> : state === "playing" ? <Square size={15} /> : <Play size={15} />}
    </Button>
  );
}
